import React, { useState, useEffect, useCallback, useLayoutEffect } from "react"

import shortid from "shortid"
import WindowContext from "../../contexts/WindowContext"
import ReferralContext from "../../contexts/ReferralContext"
import Footer from "../../components/footer/Footer"
import Nav from "./nav/Nav"
import styles from "./Layout.module.css"
import RegistrationForm from "../../components/registrationForm/RegistrationForm"

function Layout(props) {
  const [showForm, setShowForm] = useState(false)

  const [windowDimensions, setWindowDimensions] = useState(() => {
    // For SSR Gatsby build
    let initialState = { width: 750, height: 1334 }
    if (typeof window !== "undefined") {
      initialState = { width: window.innerWidth, height: window.innerHeight }
    }
    return initialState
  })

  // Id of referrer ?ref=xyz query string
  const [referralContext, setReferralContext] = useState({
    referrerId: null,
    userReferralId: shortid(),
  })

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
    const queryParams = new URLSearchParams(props.location.search)
    const ref = queryParams.get("ref")
    console.log("referred by:", ref)
    if (ref) setReferralContext(prev => ({ ...prev, referrerId: ref }))
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const handleResize = useCallback(() => {
    // When finished resizing update scroll height and set to new relative scroll position
    const windowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    }
    setTimeout(() => {
      if (
        windowSize.width === window.innerWidth &&
        windowSize.height === window.innerHeight
      ) {
        setWindowDimensions(windowSize)
      }
    }, 300)
  }, [])

  const toggleForm = useCallback(() => {
    setShowForm(prev => !prev)
  }, [])

  return (
    <ReferralContext.Provider value={referralContext}>
      <WindowContext.Provider value={windowDimensions}>
        <main className={styles.main}>
          <Nav toggleForm={toggleForm} />
          <div>{props.children}</div>
          <Footer showForm={toggleForm} />
          <RegistrationForm show={showForm} closePressed={toggleForm} />
        </main>
      </WindowContext.Provider>
    </ReferralContext.Provider>
  )
}
export default Layout
